import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";

 const AnalysisTypeFilter = ({
  handleApplyFilters,
  currentAnalysisTypes,
  filters,
  isRTL,
  t,
 }) => {
    const currentAnalysisType = currentAnalysisTypes.find(
      (type) => type.value == filters.analysisType
    );

    return (
      <Box h="full">
        <Menu>
          <MenuButton
            w="full"
            variant="outline"
            size="sm"
            textAlign={isRTL ? "right" : "left"}
            h="40px"
            display="flex"
            alignItems="center"
          >
            <HStack spacing={2} w="full" justify={isRTL ? "flex-end" : "flex-start"}>
              {isRTL && <Icon as={FaChevronDown} />}
              <Text noOfLines={1} flex={1}>
                {currentAnalysisType?.label || t("reports.select", "اختر")}
              </Text>
              {!isRTL && <Icon as={FaChevronDown} />}
            </HStack>
          </MenuButton>
          <MenuList>
            {currentAnalysisTypes.map((type) => (
              <MenuItem
                key={type.value}
                onClick={() => handleApplyFilters({ analysisType: type.value })}
                fontWeight={
                  type.value === filters.analysisType ? "bold" : "normal"
                }
                bg={type.value === filters.analysisType ? "blue.50" : "white"}
                textAlign={isRTL ? "right" : "left"}
              >
                {type.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
    );
  };
export default AnalysisTypeFilter;
